import React from 'react';
import I18n from 'i18n-js';

import Modal from '@reverbdotcom/commons/src/components/modal';
import ShopPoliciesData from './item2_shop_policies_data';
import { trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { MParticleEvent } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { RCButton, RCAccordion, RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { ChevronRightIcon } from '@reverbdotcom/cadence/icons/react';

interface IProps {
  listingId: string;
  clickEvent?: MParticleEvent;
  asButton?: boolean;
  asButtonStyledAsLink?: boolean;
}

function renderModalTrigger(props, onToggle) {
  if (props.asButton) {
    return (
      <RCButton
        variant="muted"
        size="small"
        onClick={onToggle}
        fullWidth
      >
        {I18n.t('discovery.item2Shop.viewPolicies')}
      </RCButton>
    );
  }

  if (props.asButtonStyledAsLink) {
    return (
      <button
        className="button-as-link color-black weight-bold"
        type="button"
        onClick={onToggle}
      >
        <RCTextWithIcon svgComponent={ChevronRightIcon}>
          {I18n.t('discovery.item2Shop.viewPolicies')}
        </RCTextWithIcon>
      </button>
    );
  }

  return (
    <RCAccordion
      id="shop-policies-modal"
      onClick={onToggle}
      asLink
      heading={I18n.t('discovery.item2Shop.viewPolicies')}
    />
  );
}

export default function ShopPoliciesModal(props: IProps) {
  const [modalOpen, setModalOpen] = React.useState(false);

  function onToggle(e) {
    e.preventDefault();
    setModalOpen(!modalOpen);
    trackEvent(props.clickEvent);
  }

  return (
    <>
      {renderModalTrigger(props, onToggle)}

      <Modal
        isOpen={modalOpen}
        onRequestClose={() => {
          setModalOpen(!modalOpen);
        }}
        headerTitle={I18n.t('discovery.item2ShopPoliciesModal.shopPolicies')}
        paddedBody
      >
        <ShopPoliciesData listingId={props.listingId} fetchData={modalOpen} />
      </Modal>
    </>
  );
}
